export interface TipoLocalRemocaoModel {
    valor: string;
    descricao: string;
}

export const TipoLocalRemocaoList: TipoLocalRemocaoModel[] = [
    { valor: "VIA_PUBLICA", descricao: "Via pública" },
    { valor: "GARAGEM_SUBSOLO", descricao: "Garagem ou subsolo" },
    { valor: "GARAGEM_NIVEL_RUA", descricao: "Garagem nível da rua " },
    { valor: "RIBANCEIRA_FORA_VIA", descricao: "Ribanceira/fora da via" },
]